export enum CheckModel {
  ALL = "ALL",
  PARENT = "PARENT",
  LEAF = "LEAF",
}
